import React from 'react';
import { Message } from 'semantic-ui-react';
import NotificationLogTable from '~/features/admin/NotificationLog/NotificationLogTable';
import { useUserContext } from '~/hooks';

export default function AdminNotificationLog() {
  const { loggedInUser } = useUserContext();

  if (!loggedInUser?.isAdmin) {
    return <Message negative>Only admin users can view the notification log.</Message>;
  }

  return (
    <div style={{ padding: '2rem' }}>
      <h1>Notification log</h1>
      <NotificationLogTable />
    </div>
  );
}
